// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --input-padding-x: .75rem;
    --input-padding-y: .75rem;
  }
  
  /* html,
  body {
    height: 100%;
  } */
  .usHeader{
    color:#ffffff;
    background-color: #007399;
    margin: auto -16px;
    padding: 0px 0px;     
    /*min-width: 890px;*/
    height: 60px;
    top: -10;
    left: 0;
}
.usHeader h1{
  color:#ffffff;
}

  body {
    display: -ms-flexbox;
    /* display: -webkit-box; */
    /* display: flex; */
    -ms-flex-align: center;
    -ms-flex-pack: center;
    align-items: center;
    justify-content: center;
    /*padding-top: 40px;*/
    /* padding-bottom: 40px; */
  }
  
  h1,h2 {
    text-align: center;
}
  .form-signin {
    padding-top: 20px;
    width: 100%;
    max-width: 420px;
    padding: 20px;
    margin: 0 auto;
    border: 0.1vw solid #f0f0f0;
    box-shadow: 0px 3px 6px 0px rgba(55, 188, 225,0.5);
  }
  
  .form-label-group {
    position: relative;
    margin-bottom: 1rem;
  }
  
  .form-label-group > input,
  .form-label-group > label {
    padding: var(--input-padding-y) var(--input-padding-x);
  }
  
  .form-label-group > label {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    margin-bottom: 0; /* Override default \`<label>\` margin */
    line-height: 1.5;
    color: #495057;
    border: 1px solid transparent;
    border-radius: .25rem;
    transition: all .1s ease-in-out;
  }
  
  .form-label-group input::placeholder {
    color: transparent;
  }
  
  .form-label-group input:not(:placeholder-shown) {
    padding-top: calc(var(--input-padding-y) + var(--input-padding-y) * (2 / 3));
    padding-bottom: calc(var(--input-padding-y) / 3);
  }
  
  .form-label-group input:not(:placeholder-shown) ~ label {
    padding-top: calc(var(--input-padding-y) / 3);
    padding-bottom: calc(var(--input-padding-y) / 3);
    font-size: 12px;
    color: #777;
  }
    `, "",{"version":3,"sources":["webpack://./src/user/user.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;;;KAGG;EACH;IACE,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;IACZ,QAAQ;IACR,OAAO;AACX;AACA;EACE,aAAa;AACf;;EAEE;IACE,oBAAoB;IACpB,0BAA0B;IAC1B,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IAErB,mBAAmB;IAEnB,uBAAuB;IACvB,qBAAqB;IACrB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;AACtB;EACE;IACE,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,2BAA2B;IAC3B,kDAAkD;EACpD;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;IAEE,sDAAsD;EACxD;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,cAAc;IACd,WAAW;IACX,gBAAgB,EAAE,sCAAsC;IACxD,gBAAgB;IAChB,cAAc;IACd,6BAA6B;IAC7B,qBAAqB;IACrB,+BAA+B;EACjC;;EAkBA;IACE,kBAAkB;EACpB;;EAEA;IACE,4EAA4E;IAC5E,gDAAgD;EAClD;;EAEA;IACE,6CAA6C;IAC7C,gDAAgD;IAChD,eAAe;IACf,WAAW;EACb","sourcesContent":[":root {\n    --input-padding-x: .75rem;\n    --input-padding-y: .75rem;\n  }\n  \n  /* html,\n  body {\n    height: 100%;\n  } */\n  .usHeader{\n    color:#ffffff;\n    background-color: #007399;\n    margin: auto -16px;\n    padding: 0px 0px;     \n    /*min-width: 890px;*/\n    height: 60px;\n    top: -10;\n    left: 0;\n}\n.usHeader h1{\n  color:#ffffff;\n}\n\n  body {\n    display: -ms-flexbox;\n    /* display: -webkit-box; */\n    /* display: flex; */\n    -ms-flex-align: center;\n    -ms-flex-pack: center;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    justify-content: center;\n    /*padding-top: 40px;*/\n    /* padding-bottom: 40px; */\n  }\n  \n  h1,h2 {\n    text-align: center;\n}\n  .form-signin {\n    padding-top: 20px;\n    width: 100%;\n    max-width: 420px;\n    padding: 20px;\n    margin: 0 auto;\n    border: 0.1vw solid #f0f0f0;\n    box-shadow: 0px 3px 6px 0px rgba(55, 188, 225,0.5);\n  }\n  \n  .form-label-group {\n    position: relative;\n    margin-bottom: 1rem;\n  }\n  \n  .form-label-group > input,\n  .form-label-group > label {\n    padding: var(--input-padding-y) var(--input-padding-x);\n  }\n  \n  .form-label-group > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: block;\n    width: 100%;\n    margin-bottom: 0; /* Override default `<label>` margin */\n    line-height: 1.5;\n    color: #495057;\n    border: 1px solid transparent;\n    border-radius: .25rem;\n    transition: all .1s ease-in-out;\n  }\n  \n  .form-label-group input::-webkit-input-placeholder {\n    color: transparent;\n  }\n  \n  .form-label-group input:-ms-input-placeholder {\n    color: transparent;\n  }\n  \n  .form-label-group input::-ms-input-placeholder {\n    color: transparent;\n  }\n  \n  .form-label-group input::-moz-placeholder {\n    color: transparent;\n  }\n  \n  .form-label-group input::placeholder {\n    color: transparent;\n  }\n  \n  .form-label-group input:not(:placeholder-shown) {\n    padding-top: calc(var(--input-padding-y) + var(--input-padding-y) * (2 / 3));\n    padding-bottom: calc(var(--input-padding-y) / 3);\n  }\n  \n  .form-label-group input:not(:placeholder-shown) ~ label {\n    padding-top: calc(var(--input-padding-y) / 3);\n    padding-bottom: calc(var(--input-padding-y) / 3);\n    font-size: 12px;\n    color: #777;\n  }\n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
